import React from 'react'
import AirdropCountdown from './airdropcountdown'
import AppContext from '../context/appContext'
import { useContext } from 'react'
const Staking = () => {
    
    const appContext = useContext(AppContext)

    const { authToken, createAccount,setAuthToken,getUser,userData } = appContext
    return (
        <div>
              <div className="px-md-5">
                <h1 className="text-light">Staking Stats</h1>
            </div>
            <AirdropCountdown />

            <div className="container-fluid pt-3 pb-5">
                <div className="px-md-5">

                    <div data-aos="fade-up" data-aos-duration="1000" className="row">
                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    {/* <span className="text-light">{userData.level}</span> */}
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`$${userData.level>4?1000:userData.level<4?100:500}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Total Staked</h2>
                                    <p class="card-text text-light">Initial staking amount at the time of registration</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>20%</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Monthly Reward</h2>
                                    <p class="card-text text-light">Monthly staking reward according to your current level</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.stakingAmount * 1000) / 1000}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Staking Rewards</h2>
                                    <p class="card-text text-light">Total staking reward earned according to your current level</p>

                                </div>
                            </div>
                        </div>
                      
                       




                    </div>
                </div>
            </div>
        </div>
    )
}

export default Staking